/**************************************************************************************************/
/*   File: /src/app/stores/reducers/root/reducer.ts                                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Thu May 30 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { storeFreeze } from 'ngrx-store-freeze';

import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';

import { environment } from '../../../../environments/environment';
import * as fromStates from '../../states';
import * as fromAuthorization from '../authorization';
import * as fromDossiers from '../dossiers';
import * as fromDownload from '../download';
import * as fromCreation from '../creation';
import * as fromDetails from '../details';
import * as fromEditing from '../editing';
import * as fromUi from '../ui';

/**
 * The newplan frontend reducers
 */
export const rootReducer: ActionReducerMap<fromStates.fromRoot.RootState> = {
  ui: fromUi.uiReducer,
  authorization: fromAuthorization.authorizationReducer,
  download: fromDownload.downloadReducer,
  creation: fromCreation.creationReducer,
  details: fromDetails.detailsReducer,
  editing: fromEditing.editingReducer,
  router: routerReducer,
  dossiers: fromDossiers.dossiersReducer
};

/**
 * The metareducers
 */
/* istanbul ignore next */
export const metaReducers: MetaReducer<fromStates.fromRoot.RootState>[] = !environment.production ? [storeFreeze] : [];
